import $ from 'jquery';

import AsyncView from './AsyncView';
import Product from './Product';
import ScrollLock from '../utils/ScrollLock';

const DEBUG = false;
const instance = null;

function _onContentClick(event) {
  event.stopPropagation();
}

export default class Quickshop {
  constructor() {
    if (instance) {
      return instance;
    }

    this.instance = this;
    this.el = document.querySelector('[data-quickshop]');
    this.contentEl = document.querySelector('[data-quickshop-content]');
    this.closeEl = document.querySelector('[data-quickshop-close]');
    this.injectEl = document.querySelector('[data-quickshop-product-inject]');
    this.settingsSha256 = this.el.getAttribute('data-quickshop-settings-sha256');
    this.useCaching = !DEBUG && !(window.Shopify && window.Shopify.designMode);

    this.deferred = {};

    this.onCloseClick = this.close.bind(this);
  }

  open(url, productSha256) {
    const $deferred = $.Deferred();

    this.el.addEventListener('click', this.onCloseClick);
    this.contentEl.addEventListener('click', _onContentClick);
    this.closeEl.addEventListener('click', this.onCloseClick);

    this.el.classList.add('quickshop-visible');

    AsyncView.load(
      url,
      'ajax',
      productSha256,
      this.settingsSha256,
    ).done((data) => {
      this.injectEl.innerHTML = data.html;
      this.product = new Product({ el: this.injectEl, data: data.options });

      this.el.classList.add('quickshop-loaded');
      ScrollLock.lock();

      return $deferred.resolve();
    }).fail($deferred.reject());

    return $deferred.promise();
  }

  close() {
    if (this.product != null) {
      this.product.unload();
    }

    if (this.rte != null) {
      this.rte.unload();
    }

    ScrollLock.unlock();

    this.el.removeEventListener('click', this.onCloseClick);
    this.contentEl.removeEventListener('click', _onContentClick);
    this.closeEl.removeEventListener('click', this.onCloseClick);

    this.el.classList.remove('quickshop-loaded');
    this.el.classList.remove('quickshop-visible');
  }

  unload() {
    this.close();
    this.instance = null;
  }
}
